// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-section {
    padding: 0 32px;
    text-align: center;
    background-color: white;
}
.info-title-content {
    margin: 64px 0 128px 0;
}
.info-title {
    font-family: 'Inter', sans-serif;
    font-size: 40px;
    font-weight: bold;
}
.info-title > span {
    position: relative;
}
.info-title span::before {
    content: '';
    position: absolute;
    width: 75%;
    height: 4px;
    background-color: #9D2553;
    border-radius: 8px;
    left: 0;
    bottom: -12px;
}
.info-description {
    margin: 64px;
    text-align: center;
    color: rgb(77, 75, 75);
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    letter-spacing: .8px;
    line-height: 1.8rem;
}
/* Cards */
.info-cards-content {
    margin: 64px 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
}
.info-cards {
    height: auto;
    border: 2px solid #d7d3d3;
    border-radius: 12px;
    background-color: white;
    position: relative;
}
.info-card-title {
    margin: 32px 0 40px 0;
    color: black;
    font-family: 'Inter', sans-serif;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: .8px;
}
.info-card-description {
    margin: 24px;
    color: rgb(77, 75, 75);
    font-family: 'Rubik', sans-serif;
    font-size: 18px;
    letter-spacing: .8px;
    line-height: 1.5rem;
}
.info-card-icon {
    position: absolute;
    top: -24px;
    left: 44%;
    padding: 10px;
    background-color: #DCE6FF;
    border-radius: 30px;
}
.info-fa-icon {
    color: #2e5288;
    font-size: 24px;
}
/* Responsive */
@media screen and (max-width: 1000px) {
    .info-description {
        margin: 64px 32px;
    }
    .info-cards-content {
        grid-template-columns: repeat(2, 1fr);
    }
}
@media screen and (max-width: 700px) {
    .info-description {
        margin: 64px 8px;
    }
    .info-cards-content {
        grid-template-columns: repeat(1, 1fr);
    }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Info.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,OAAO;IACP,aAAa;AACjB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;AACA,UAAU;AACV;IACI,cAAc;IACd,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,gCAAgC;IAChC,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA,eAAe;AACf;IACI;QACI,iBAAiB;IACrB;IACA;QACI,qCAAqC;IACzC;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".info-section {\n    padding: 0 32px;\n    text-align: center;\n    background-color: white;\n}\n.info-title-content {\n    margin: 64px 0 128px 0;\n}\n.info-title {\n    font-family: 'Inter', sans-serif;\n    font-size: 40px;\n    font-weight: bold;\n}\n.info-title > span {\n    position: relative;\n}\n.info-title span::before {\n    content: '';\n    position: absolute;\n    width: 75%;\n    height: 4px;\n    background-color: #9D2553;\n    border-radius: 8px;\n    left: 0;\n    bottom: -12px;\n}\n.info-description {\n    margin: 64px;\n    text-align: center;\n    color: rgb(77, 75, 75);\n    font-family: 'Inter', sans-serif;\n    font-size: 18px;\n    letter-spacing: .8px;\n    line-height: 1.8rem;\n}\n/* Cards */\n.info-cards-content {\n    margin: 64px 0;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 32px;\n}\n.info-cards {\n    height: auto;\n    border: 2px solid #d7d3d3;\n    border-radius: 12px;\n    background-color: white;\n    position: relative;\n}\n.info-card-title {\n    margin: 32px 0 40px 0;\n    color: black;\n    font-family: 'Inter', sans-serif;\n    font-size: 28px;\n    font-weight: bold;\n    letter-spacing: .8px;\n}\n.info-card-description {\n    margin: 24px;\n    color: rgb(77, 75, 75);\n    font-family: 'Rubik', sans-serif;\n    font-size: 18px;\n    letter-spacing: .8px;\n    line-height: 1.5rem;\n}\n.info-card-icon {\n    position: absolute;\n    top: -24px;\n    left: 44%;\n    padding: 10px;\n    background-color: #DCE6FF;\n    border-radius: 30px;\n}\n.info-fa-icon {\n    color: #2e5288;\n    font-size: 24px;\n}\n/* Responsive */\n@media screen and (max-width: 1000px) {\n    .info-description {\n        margin: 64px 32px;\n    }\n    .info-cards-content {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n@media screen and (max-width: 700px) {\n    .info-description {\n        margin: 64px 8px;\n    }\n    .info-cards-content {\n        grid-template-columns: repeat(1, 1fr);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
